<app-loader></app-loader>
<ng-template #schoolDashboardDescription>
  <div class="w-100 d-flex">
    <div class="d-flex align-items-center mr-auto">
      <mat-icon class="large-icon-size mx-3" [inline]="true">account_balance</mat-icon>
      <h2 class="txt-light mb-0">
        {{ schoolData?.schoolName }}
      </h2>
    </div>

    <a mat-button class="ml-auto font-weight-normal header-link" routerLink="/dashboard" [queryParams]="{ ns: 'true' }">
      <span>Find Another School</span>
      <mat-icon class="large-icon-size mx-3" [inline]="true">search</mat-icon>
    </a>
  </div>
</ng-template>

<ng-template #schoolDashboardContent>
  <mat-tab-group>
    <mat-tab label="School">
      <ng-template matTabContent>
        <mat-button-toggle-group
          class="sub-menu wrapping-button-toggle-group center-nav"
          #activityHistoryToggleGroup="matButtonToggleGroup"
          value="general-information-toggle"
        >
          <mat-button-toggle value="general-information-toggle">
            School Information
          </mat-button-toggle>
          <mat-button-toggle value="address-information-toggle">
            Address Information
          </mat-button-toggle>
          <mat-button-toggle value="contact-information-toggle">
            Contact's Information
          </mat-button-toggle>
        </mat-button-toggle-group>

        <app-school-general-information
          [selectedSchoolId]="selectedSchoolId"
          *ngIf="activityHistoryToggleGroup.value === 'general-information-toggle'"
        >
        </app-school-general-information>
        <app-school-disbursement-information
          [selectedSchoolId]="selectedSchoolId"
          *ngIf="activityHistoryToggleGroup.value === 'contact-information-toggle'"
        >
        </app-school-disbursement-information>
        <app-school-address-information
          [selectedSchoolId]="selectedSchoolId"
          *ngIf="activityHistoryToggleGroup.value === 'address-information-toggle'"
        >
        </app-school-address-information>
        <app-school-contact-information
          [selectedSchoolId]="selectedSchoolId"
          *ngIf="activityHistoryToggleGroup.value === 'contact-information-toggle'"
        >
        </app-school-contact-information>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</ng-template>

<app-collapsible-card [description]="schoolDashboardDescription" [content]="schoolDashboardContent" [open]="open">
</app-collapsible-card>
